'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reverse2 = require('./_internal/_reverse');

var _reverse3 = _interopRequireDefault(_reverse2);

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _call = require('./call');

var _call2 = _interopRequireDefault(_call);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

var _executeOn = require('./executeOn');

var _executeOn2 = _interopRequireDefault(_executeOn);

var _executeWith = require('./executeWith');

var _executeWith2 = _interopRequireDefault(_executeWith);

var _or = require('./or');

var _or2 = _interopRequireDefault(_or);

var _mapBy = require('./mapBy');

var _mapBy2 = _interopRequireDefault(_mapBy);

var _spread = require('./spread');

var _spread2 = _interopRequireDefault(_spread);

var _toFunction = require('./toFunction');

var _toFunction2 = _interopRequireDefault(_toFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapToFunction = (0, _mapBy2.default)(_toFunction2.default); /**
                                                                 * Take an array of functions (or values) and determine if one result is
                                                                 * true given value
                                                                 *
                                                                 * @module orWith
                                                                 * @func
                                                                 * @since 1.10.0
                                                                 * @param {Array} args
                                                                 * @param {*} val
                                                                 * @return {boolean|function}
                                                                 * @example
                                                                 *
                                                                 *     const foo = val => val > 10;
                                                                 *     const bar = val => val < 5;
                                                                 *     orWith([foo, bar], 6); //=> false
                                                                 *     orWith([foo, bar])(1); //=> true
                                                                 */

var updateArgs = (0, _executeWith2.default)(_mapBy2.default, _executeOn2.default, mapToFunction);
var callUpdateArgs = (0, _call2.default)(updateArgs);
var internal = (0, _compose2.default)(_or2.default, callUpdateArgs, _reverse3.default, _spread2.default);

var orWith = (0, _define2.default)(internal, _INT_TWO2.default);

exports.default = orWith;